<template>
  <form>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("title") }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <p>{{ $t("copy") }}</p>
        <br />
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('name')" :type="{ 'is-danger': $v.name.$error }">
              <b-input v-model="name" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('company')" :type="{ 'is-danger': $v.company.$error }">
              <b-input v-model="company" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('charge')" :type="{ 'is-danger': $v.charge.$error }">
              <b-input v-model="charge" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('email')" :type="{ 'is-danger': $v.email.$error }">
              <b-input v-model="email" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('phone')" :type="{ 'is-danger': $v.phone.$error }">
              <b-input v-model="phone" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field :label="$t('message')" :type="{ 'is-danger': $v.message.$error }">
              <b-input type="textarea" v-model="message" :required="true" :disabled="loading">
              </b-input>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :label="$t('close')" @click="$emit('close')" />
        <b-button :label="$t('send')" @click="submit()" :loading="loading" :disabled="loading" type="is-primary" />
      </footer>
    </div>
  </form>
</template>
<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { EmailClient } from "@azure/communication-email";

const connectionString = `endpoint=https://azurecomservice5.unitedstates.communication.azure.com/;accesskey=oGydbXIerxkovTxUwA9+ygG0c6YdNPQHSpdH7qUXnMcDjC25y8u3b7Q85BW0NzRxJWBv2IWcIYN8sAxIwHhWhw==`;
const client = new EmailClient(connectionString);

export default {
  name: "DemoForm",
  data() {
    return {
      title: "DemoForm",
      name: "",
      company: "",
      charge: "",
      email: "",
      phone: "",
      message: "",
      loading: false,
    };
  },
  methods: {
    async submit() {
      try {

        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loading = true;

        const message = {
          senderAddress: "DoNotReply@ceptinel.com",
          content: {
            subject: "Demo Request from " + this.name,
            plainText: `
              Name: ${this.name}\n
              Company: ${this.company}\n
              Charge: ${this.charge}\n
              Email: ${this.email}\n
              Phone: ${this.phone}\n
              Message: \n${this.message}`,
          },
          recipients: {
            to: [
              {
                address: "info@ceptinel.cl",
                displayName: "info",
              },
              {
                address: "rmontes@ceptinel.cl",
                displayName: "rmontes",
              }
            ],
          },
        };

        const poller = await client.beginSend(message);
        
        await poller.pollUntilDone();
        


        this.loading = false;
        this.$emit("close");
        this.$buefy.snackbar.open({
          message: this.$t("sendSucces"),
          type: "is-success",
          position: "is-bottom",
          duration: 5000,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  validations: {
    name: { required, minLength: minLength(2) },
    company: { required, minLength: minLength(2) },
    charge: { required, minLength: minLength(2) },
    email: { required, email },
    phone: { required, minLength: minLength(2) },
    message: { required, minLength: minLength(2) },
  },
};
</script>

<i18n>
{
  "es": {
    "name": "Nombre",
    "company": "Empresa",
    "charge": "Cargo",
    "email": "Correo Electrónico",
    "phone": "Teléfono",
    "message": "Mensaje",
    "send":"Enviar mensaje",
    "close":"Cancelar",
    "title":"Solicitar una demostración",
    "copy":"Completa el formulario y le contactaremos pronto.",
    "sendSucces":"¡Mensaje enviado!"
  },
  "en": {
    "name": "Name",
    "company": "Company",
    "charge": "Charge",
    "email": "Email",
    "phone": "Phone",
    "message": "Message",
    "send":"Send Message",
    "close":"Cancel",
    "title":"Request a Demo",
    "copy":"Complete the form and we will contact you soon.",
    "sendSucces":"Message sent!"
  },
  "pt": {
    "name": "Nome",
    "company": "Companhia",
    "charge": "Posição",
    "email": "E-mail",
    "phone": "Telefone",
    "message": "Mensagem",
    "send":"Enviar mensagem",
    "close":"Cancelar",
    "title":"Solicite uma demonstração",
    "copy":"Preencha o formulário e em breve entraremos em contato.",
    "sendSucces":"¡Mensagem enviada!"
  }
}
</i18n>
